export const isPast = (date) => {
    if (!date)
        return false;
    const today = new Date();
    const inputDate = new Date(date);
    if (isNaN(inputDate.getTime()))
        return false;
    return inputDate < today;
};
